import React, { useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import axios from "axios";

const formId = "bae94b89-ef22-48bf-aff1-4353dd633721";

const NewsletterForm = ({ className }) => {
  const [isSubmitted, setIsSubmitted] = useState(false);

  const validate = (values) => {
    const errors = {};
    if (!values.email) {
      errors.email = "Required Field";
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)) {
      errors.email = "Invalid email address";
    }

    return errors;
  };

  const submitData = (values, { setSubmitting }) => {
    console.log(values);

    //const formGuid = "9e74014a-39e1-403a-8bb7-e99c60f7f3f5";
    const formGuid = formId;
    const portalId = "26165421";

    //const hutk = document.cookie.replace(/(?:(?:^|.*;\s*)hubspotutk\s*\=\s*([^;]*).*$)|^.*$/, "$1")

    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };

    //console.log( document.location.href )
    const data = {
      fields: [
        {
          name: "email",
          value: values.email,
        }, //,
        // {
        //   name: "message",
        //   value: values.message,
        // },
      ],
    };

    const url = `https://api.hsforms.com/submissions/v3/integration/submit/${portalId}/${formGuid}`;
    console.log(url);

    axios.post(url, data, config).then(
      (response) => {
        console.log(response);
        setSubmitting(false);
        setIsSubmitted(true);
      },
      (error) => {
        console.log(error);
      }
    );
  };

  if (isSubmitted) {
    return (
      <div className={className}>
        <div>Stay updated</div>
        <div>Thank you.</div>
      </div>
    );
  }

  return (
    <div className={className}>
      {/* <h1>Any place in your app!</h1> */}
      <div className="uppercase font-semibold">Stay updated</div>
      <Formik
        initialValues={{ email: "" }}
        validate={validate}
        onSubmit={submitData}
        //className={className}
      >
        {({ isSubmitting }) => (
          <Form>
            <div className=" ">
              <div className=" ">
                <div className="flex flex-row justify-between border-b border-white">
                  <div className="w-fit">
                    <Field
                      type="email"
                      name="email"
                      placeholder="Work email"
                      className="p-1 pl-0 inline-block w-full bg-[#282D33]"
                    />
                  </div>
                  <div className="">
                    <button
                      type="submit"
                      disabled={isSubmitting}
                      className="hover:bg-gray-100 rounded py-1 px-1  text-white text-sm font-semibold text-center 
                      text-nowrap whitespace-nowrap bg-[#282D33]"
                    >
                      {"->"}
                    </button>
                  </div>
                </div>

                <div className="">
                  <ErrorMessage
                    name="email"
                    component="div"
                    className="py-2 text-[#ff0000]"
                  />
                </div>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default NewsletterForm;
